import { defineComponent as _defineComponent } from 'vue'
import { usePublicSalesStore } from "@/store/publicSales.store";
import {computed, onBeforeMount, onUnmounted, ref} from "vue";
import CoinAmount from "@/components/commons/CoinAmount.vue";
import {useI18n} from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'PublicSaleInfo',
  setup(__props, { expose: __expose }) {
  __expose();

const publicSalesStore = usePublicSalesStore();

let startDateIntevalId = 0;
let endDateIntervalId = 0;
const timeToStart = ref();
const timeToEnd = ref();

onBeforeMount(() => {
  startDateIntevalId = window.setInterval(() => {
    timeToStart.value = calculateTimeToPAss(new Date(Date.now()), startDate.value);
  }  , 1000);
  endDateIntervalId = window.setInterval( () => {
    timeToEnd.value = calculateTimeToPAss(startDate.value, endDate.value);
  }, 1000);
});

onUnmounted(() => {
  window.clearInterval(startDateIntevalId);
  window.clearInterval(endDateIntervalId);
});

const total = computed(() =>{
  return publicSalesStore.roundInfo?.totalTokens;
});

// const parts = computed(() =>{
//   return publicSalesStore.getParts;
// });

const currency = computed(() => {
  return publicSalesStore.getC4eToUSD;
});

const startDate = computed(() => {
  return publicSalesStore.roundInfo?.startDate;
});
const endDate = computed(() => {
  return publicSalesStore.roundInfo?.endDate;
});

const i18n = useI18n();

function calculateTimeToPAss(startDate: Date | undefined, endDate: Date | undefined){
  if (startDate == undefined || endDate == undefined) {
    return '-';
  }
  if(startDate.getTime() < endDate.getTime()){

    const now = new Date(Date.now());
    const diference = new Date(endDate).getTime() - now.getTime();
    if (diference < 0) return null;
    const days = Math.floor(diference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diference % (1000 * 60)) / 1000);
    return `${days}D ${hours}H ${minutes}M ${seconds}S`;
  } else {
    return i18n.t('BUY_TOKENS_VIEW.ALREADY_STARTED');
  }
}

// const total = ref(new Coin(BigInt(250000000),'c4e'));
//
// const values = ref([
//   {
//     amount: new Coin(105000000n, 'c4e'),
//     color: '#81CF1F'
//   },
//   {
//     amount: new Coin(10000n, 'uc4e'),
//     color: '#CAE7FF'
//   }
//   ]);

const __returned__ = { publicSalesStore, get startDateIntevalId() { return startDateIntevalId }, set startDateIntevalId(v) { startDateIntevalId = v }, get endDateIntervalId() { return endDateIntervalId }, set endDateIntervalId(v) { endDateIntervalId = v }, timeToStart, timeToEnd, total, currency, startDate, endDate, i18n, calculateTimeToPAss, get usePublicSalesStore() { return usePublicSalesStore }, CoinAmount }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})